import { isEmpty, trim } from "lodash";
import API_URL from "../constant/api.config";
import axios from "axios";
import axiosInstance from '../axiosHttp';
import { setAuthHeaders } from '../utils/common';
import { encode } from "js-base64";

export const getQuantityUnitList = () => async (dispatch) => {

  return await axios.get(API_URL + "/quantity-units")
    .then((response) => {
      if (response.status === 200 && response.data.status) {
        dispatch({
          type: "LIST_QUANTITY",
          payload: response.data.data
        });
        return response.data.data;
      }


    })
    .catch((error) => {
      dispatch({
        type: "LIST_QUANTITY",
        payload: error
      });
    });
}

export const getHSCodeList = () => async (dispatch) => {

  return await axios.get(API_URL + "/hs-codes")
    .then((response) => {
      if (response.status === 200 && response.data.status) {
        dispatch({
          type: "LIST_HSCODES",
          payload: response.data.data
        });
        return response.data.data;
      }


    })
    .catch((error) => {
      dispatch({
        type: "LIST_HSCODES",
        payload: error
      });
    });
}

export const getHSCodeSearchList = (search) => async (dispatch) => {
  // console.log("dsvfffffffff", search);
  return await axios.post(API_URL + '/hs-codes/hsCodesearch', {
    search_txt: search,
  }).then((response) => {
    if (response.status === 200) {
      if (response.data.status === true) {
        return response.data.data;
      }
    }
    return [];
  }).catch((error) => {
    console.log("ERROR =====", error);
  });

}

export const getSelectedHSCodeListByIdList = (ids) => async (dispatch) => {
  ids = [ids];
  return await axios.post(API_URL + '/hs-codes/hsCodeById', {
    search_txt: ids,
  }).then((response) => {
    if (response.status === 200) {
      if (response.data.status === true) {
        return response.data.data;
      }
    }
    return [];
  }).catch((error) => {
    console.log("ERROR =====", error);
  });

}

export const getCountryList = () => async (dispatch) => {
  return await axios.get(API_URL + "/countries")
    .then((response) => {
      if (response.status === 200 && response.data.status) {
        dispatch({
          type: "LIST_COUNTRIES",
          payload: response.data.data
        });
        return response.data.data;
      }
      return [];


    })
    .catch((error) => {
      dispatch({
        type: "LIST_COUNTRIES",
        payload: error
      });
    });
}

export const getCityList = (countryId) => async (dispatch) => {
  return await axios.get(API_URL + '/cities/' + countryId).then((response) => {
    if (response.status === 200) {
      if (response.data.status === true) {
        // dispatch({
        //   type: "LIST_COUNTRIES",
        //   payload: response.data.data
        // });
        return response.data.data;
      }
    }
    return [];
  }).catch((err) => {
    console.log("Error ============= ", err);
  });
}

export const getCityListBySerachVal = (searchTxt, countryId) => async (dispatch) => {

  return await axios.post(API_URL + '/cities/search', {
    search_txt: searchTxt,
    country_id: countryId
  }).then((response) => {
    if (response.status === 200) {
      if (response.data.status === true) {
        return response.data.data;
      }
    }
    return [];
  });
}

export const getPortsByCountry = (countryId) => async (dispatch) => {

  return await axios.get(API_URL + '/ports/' + countryId).then((response) => {
    if (response.status === 200) {
      if (response.data.status === true) {
        // dispatch({
        //   type: "LIST_COUNTRIES",
        //   payload: response.data.data
        // });
        return response.data.data;
      }
    }
    return [];
  }).catch((err) => {
    console.log("Error ============= ", err);
  });
}

export const getServices = () => async () => {
  return await axios.get(API_URL + '/services').then((response) => {

    if (response.status === 200) {
      // if (response.data.status === true) {
      // console.log("Response ========== ", response.data.data);
      return response.data.data;
      // }
    }
    return [];
  }).catch((err) => {
    console.log("Error ============= ", err);
  });
}

export const getHScodeSuggetions = (offset, limit, searchTxt) => async () => {

  searchTxt = trim(searchTxt);
  const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
  return await axios.get(API_URL + `/hs-codes-suggetions/${offset}/${limit}/code/ASC${searchQueryString}`).then((response) => {
    if (response.status === 200) {
      // if (response.data.status === true) {
      // console.log("Response ========== ", response.data.data);
      return response.data.data;
      // }
    }
    return [];
  }).catch((err) => {
    console.log("Error ============= ", err);
  });
}

export const getServicesList = (offset, limit, searchTxt) => async () => {

  searchTxt = trim(searchTxt);
  const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
  return await axios.get(API_URL + `/servcies-list/${offset}/${limit}${searchQueryString}`).then((response) => {
    if (response.status === 200) {
      // if (response.data.status === true) {
      // console.log("Response ========== ", response.data.data);
      return response.data.data;
      // }
    }
    return [];
  }).catch((err) => {
    console.log("Error ============= ", err);
  });
}

export const getServiceByIndustry = (industry_id) => async () => {

  return await axios.get(API_URL + `/industry-services/${industry_id}`).then((response) => {

    if (response.status === 200) {
      // if (response.data.status === true) {
      // console.log("Response ========== ", response.data.data);
      return response.data.data;
      // }
    }
    return [];
  }).catch((err) => {
    console.log("Error ============= ", err);
  });
}

export const getIndustryByTradeMode = (trade_mode) => async () => {
  return await axios.get(API_URL + `/trading-industries/${trade_mode}`).then((response) => {
    if (response.status === 200) {
      // if (response.data.status === true) {
      // console.log("Response ========== ", response.data);
      return response.data;
      // }
    }
    return [];
  }).catch((err) => {
    console.log("Error ============= ", err);
  });
}


export const getHSCodeFilterMemberPieChart = () => async (dispatch) => {
  const headers = setAuthHeaders();
  return await axiosInstance.get(API_URL + "/pieChartData", { headers })
    .then((response) => {
      if (response.status === 200 && response.data.status) {
        dispatch({
          type: "PIE_CHART_HSCODES",
          payload: response.data.data
        });
        return response.data.data;
      }
    })
    .catch((error) => {
      dispatch({
        type: "PIE_CHART_HSCODES",
        payload: error
      });
    });
}

export const getTargetCountryMapChartData = () => async (dispatch) => {
  const headers = setAuthHeaders();
  return await axiosInstance.get(API_URL + "/countryChart", { headers })
    .then((response) => {
      if (response.status === 200 && response.data.status) {
        dispatch({
          type: "MAP_CHART_TARGET_COUNTRY",
          payload: response.data.data
        });
        return response.data.data;
      }
    })
    .catch((error) => {
      dispatch({
        type: "MAP_CHART_TARGET_COUNTRY",
        payload: error
      });
    });
}

export const getTradeHScodeSuggetions = (offset, limit, searchTxt) => async () => {

  searchTxt = trim(searchTxt);
  const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
  return await axios.get(API_URL + `/trade-hs-codes-suggetions/${offset}/${limit}/hs_code/ASC${searchQueryString}`).then((response) => {
    if (response.status === 200) {
      return response.data.data;
      // }
    }
    return [];
  }).catch((err) => {
    console.log("Error ============= ", err);
  });
}


export const getLogisticList = () => async (dispatch) => {
  return await axios.get(API_URL + "/logistic-member")
    .then((response) => {
      if (response.status === 200 && response.data.status) {
        dispatch({
          type: "LIST_LOGISTIC",
          payload: response.data.data
        });
        return response.data.data;
      }
      return [];


    })
    .catch((error) => {
      dispatch({
        type: "LIST_LOGISTIC",
        payload: error
      });
    });
}

export const searchPortList = (searchTxt = null) => async (dispatch) => {
  const headers = setAuthHeaders();
  searchTxt = trim(searchTxt);
  searchTxt = encode(searchTxt);
  const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
  return await axiosInstance.get(API_URL + '/search-port-list' + searchQueryString, { headers }).then((response) => {
    return response;
  }).catch((err) => {
    console.log("Error ==== ", err);
  })
}


export const searchPortData = (offset, limit, searchTxt) => async () => {

  searchTxt = trim(searchTxt);
  searchTxt = encode(searchTxt);
  const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
  return await axios.get(API_URL + `/all-port-list/${offset}/${limit}${searchQueryString}`).then((response) => {
    if (response.status === 200) {
      // if (response.data.status === true) {
      // console.log("Response ========== ", response.data.data);
      return response.data.data;
      // }
    }
    return [];
  }).catch((err) => {
    console.log("Error ============= ", err);
  });
}

export const adminDashboardData = (data) => async (dispatch) => {
  const headers = setAuthHeaders();
  return await axiosInstance.post(API_URL + "/adminDashboardData", data, { headers })
    .then((response) => {
      if (response.status === 200 && response.data.status) {
        dispatch({
          type: "ADMIN_DASHBOARD",
          payload: response.data
        });
        return response.data;
      }
    })
    .catch((error) => {
      dispatch({
        type: "ADMIN_DASHBOARD",
        payload: error
      });
    });
}

export const getNewsBlogList = () => async (dispatch) => {
  return await axiosInstance.get(API_URL + '/newsBlog').then((response) => {
    if (response.status === 200) {
      return response.data;
    } else {
      return [];
    }

  }).catch((err) => {
    console.log("Error ==== ", err);
  })
}

export const getCategories = () => async (dispatch) => {
  return await axios.get(API_URL + "/categories").then((response) => {
    if (response.status === 200) {
      return response.data.data;
    } else {
      return [];
    }
  });
}

export const deleteOTP = (id) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.delete(API_URL + '/otp/' + id, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}







